/* eslint-disable no-nested-ternary */
import { Dimensions, Platform } from "react-native";
import { mWarn } from "utils/logger";
import { USER_SEARCH, CREATE_USER } from "screens/LoginRegistration/queries";
import { graphQLQueryHelper, graphQLClientMutationHelper } from "utils/graphQL";
import { pushClevertapEvent } from "utils/clevertapEvents";
import { getUTMObject } from "screens/LoginRegistration/utils";
import {
  retrieveDataFromAsyncStorage,
  removeDataFromAsyncStorage
} from "screens/common/utils";
import objectPath from "object-path";

const createUser = async ({
  phoneNumber,
  whatsappSubscribed,
  client,
  goNext
}) => {
  const DesktopWidth = Dimensions.get("window").width > 800;

  const registrationSource =
    Platform.OS === "web" && DesktopWidth
      ? "RECRUIT_WEB_CANDIDATE"
      : Platform.OS === "web" && !DesktopWidth
      ? "MOBILE_WEB"
      : "MOBILE_APP";

  const userpayload = {
    mobile: phoneNumber,
    whatsapp_subscribed: whatsappSubscribed,
    whatsapp_chatbot_subscribed: true,
    registration_source: registrationSource,
    user_type: "CANDIDATE"
  };

  const objectMutation = { user: userpayload };

  // const payload = { user: userpayload };

  const utmObject = getUTMObject();

  let dseReferralDetails = await retrieveDataFromAsyncStorage("dseReferral");
  const twoDays = 60 * 60 * 24 * 2;
  const currentTime = new Date();

  if (dseReferralDetails) {
    const dateObj = new Date(objectPath.get(dseReferralDetails, "timeCreated"));
    if (currentTime - dateObj > twoDays) {
      removeDataFromAsyncStorage("dseReferral");
      dseReferralDetails = null;
    }
  }

  if (objectPath.get(dseReferralDetails, "dseId")) {
    objectMutation.referred_by_id = objectPath.get(dseReferralDetails, "dseId");
  }

  if (utmObject && Object.keys(utmObject).length) {
    objectMutation.user.marketing_source = utmObject;
  }

  const { data, error } = await graphQLClientMutationHelper(client)({
    mutation: CREATE_USER,
    variables: {
      payload: {
        ...objectMutation
      }
    }
  });

  if (error) {
    pushClevertapEvent("Welcome Submit Response", {
      Current_Page: "New loginRegistration",
      Page_Modal: "Welcome - Signup",
      Status: "F",
      User_Type: "New User",
      Platform: registrationSource
    });
    mWarn(`Got an error while creating user:\n ${error}`);
    return;
  }

  pushClevertapEvent("Welcome Submit Response", {
    Current_Page: "New loginRegistration",
    Page_Modal: "Welcome - Signup",
    Status: "S",
    User_Type: "New User",
    Platform: registrationSource
  });

  const userData = data.create.user;

  goNext({
    user: { ...userData, mobile: phoneNumber },
    isNewUser: true
  });
};

export const onSubmitHandler = async ({
  phoneNumber,
  whatsappSubscribed,
  setError,
  client,
  goNext
}) => {
  let newError = null;
  let isNewUser = false;
  const DesktopWidth = Dimensions.get("window").width > 800;

  // pushClevertapEvent("loginRegister Clicks", {
  //   Current_Page: "New loginRegistration",
  //   Page_Modal: "Welcome - Signup",
  //   Type: "Continue - Welcome Signup"
  // });

  const { data: dataObj, error } = await graphQLQueryHelper(client)({
    query: USER_SEARCH,
    variables: { query: phoneNumber }
  });

  if (error) {
    mWarn(`Got an error: ${error}`);
    return;
  }

  let userObj = {};
  const { nodes } = dataObj;

  if (nodes.edges.length > 0) {
    userObj = { ...nodes.edges[0] };
  } else {
    isNewUser = true;
  }

  if (nodes.edges.length === 0) {
    userObj.mobile = phoneNumber;
  }

  switch (userObj.user_type) {
    case "PRIMARY_AGENCY":
      newError = `This number is already registered as a Primary agent.`;
      setError(newError);
      return;
    case "EMPLOYER":
      newError = `This number is already registered as an Employer.`;
      setError(newError);
      return;
    case "PARTNER":
      newError = `This number is already registered as a Partner.`;
      setError(newError);
      return;
    case "CANDIDATE":
      // Handle Case for existing user

      pushClevertapEvent("Welcome Submit Response", {
        Current_Page: "New loginRegistration",
        Page_Modal: "Welcome - Signup",
        Status: "S",
        User_Type: "Existing User",
        Platform:
          Platform.OS === "web" && DesktopWidth
            ? "RECRUIT_WEB_CANDIDATE"
            : Platform.OS === "web" && !DesktopWidth
            ? "Mobile Web"
            : "Mobile App"
      });
      goNext({
        user: { ...userObj, mobile: phoneNumber },
        isNewUser: false
      });
      return;
    default:
      break;
  }

  // Create New User
  if (isNewUser) {
    await createUser({
      phoneNumber,
      whatsappSubscribed,
      client,
      goNext
    });
  }
};
